<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">
<path d="M41.6,31c4.5-3.1,7.4-8.2,7.4-14c0-9.4-7.6-17-17-17S15,7.6,15,17c0,5.8,2.9,10.9,7.4,14C13.5,33.8,7,42.2,7,52v12h50V52
	C57,42.2,50.5,33.8,41.6,31z M19,17c0-7.2,5.8-13,13-13s13,5.8,13,13s-5.8,13-13,13S19,24.2,19,17z M53,60H11v-8c0-9.9,8.1-18,18-18
	h6c9.9,0,18,8.1,18,18V60z"/>
</svg>
